const baseConfig = {
  basicEntities: false,
  entities: false,
  resize_enabled: false,
  disableNativeSpellChecker: false,
  // IF (4/19/21): Need to remove these plugins to allow for native spellchecking, otherwise CKE
  // hijacks the right-click menu - https://stackoverflow.com/a/45414100
  removePlugins: ['elementspath', 'contextmenu', 'liststyle', 'tabletools', 'tableselection'],
  // The (2) here makes page breaks use <br /> instead of wrapping in a <p></p>
  // Before we submit we remove the <br />
  // https://ckeditor.com/docs/ckeditor4/latest/api/CKEDITOR_config.html#cfg-enterMode
  enterMode: 2,
  shiftEnterMode: 2,
};

export const richTextEditorConfig = {
  ...baseConfig,
  toolbar: [
    { name: 'styles', items: ['EmojiPanel', 'Format'] },
    { name: 'basicstyles', groups: ['basicstyles'], items: ['Bold', 'Italic'] },
    { name: 'paragraph', groups: ['list'], items: ['NumberedList', 'BulletedList'] },
  ],
  format_tags: 'p;h1;h2;h3;h4;h5;h6',
};

export const plainTextEditorConfig = {
  ...baseConfig,
  toolbar: [{ name: 'styles', items: ['EmojiPanel'] }],
};
